import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data";
import { Reveal } from "@/components/Reveal";

export const Contact = () => {
  return (
    <section id="kontakt" className="bg-navy text-white py-24 sm:py-32" data-testid="contact-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <Reveal>
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-magenta-light">
            Kontakt
          </span>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-4 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Skontaktuj się z ekspertem
          </h2>
        </Reveal>
        <Reveal delay={140}>
          <p className="mt-6 text-base sm:text-lg text-zinc-300 leading-relaxed">
            Zadzwoń lub napisz – bezpłatnie doradzimy i przygotujemy wycenę Twojej instalacji
            elektrycznej lub systemu bezpieczeństwa.
          </p>
        </Reveal>

        <Reveal delay={200}>
          <a
            href={COMPANY.phoneHref}
            data-testid="contact-phone"
            className="block font-heading font-black text-3xl sm:text-6xl lg:text-7xl tracking-tight text-magenta-light hover:text-white transition-colors mt-10 mb-2 break-words"
          >
            {COMPANY.phone}
          </a>
        </Reveal>

        <Reveal delay={260}>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 text-zinc-300">
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="contact-email"
              className="inline-flex items-center gap-2 hover:text-magenta-light transition-colors"
            >
              <Mail className="w-5 h-5" /> {COMPANY.email}
            </a>
            <span className="inline-flex items-center gap-2">
              <MapPin className="w-5 h-5 text-magenta-light" /> {COMPANY.address}, {COMPANY.postal}
            </span>
          </div>
        </Reveal>

        <Reveal delay={290}>
          <p className="mt-4 text-sm text-zinc-400">
            Obszar działania: {COMPANY.areas.join(" · ")}
          </p>
        </Reveal>

        <Reveal delay={320}>
          <a
            href={COMPANY.phoneHref}
            data-testid="contact-cta-call"
            className="mt-12 inline-flex items-center justify-center gap-2 px-9 py-4 text-sm font-bold text-white bg-magenta hover:bg-magenta-light transition-colors"
          >
            <Phone className="w-4 h-4" strokeWidth={2.5} /> Zadzwoń teraz
          </a>
        </Reveal>
      </div>
    </section>
  );
};
